export enum EnumTipoDePontuacao{
    Cashback = 'cashback',
    PorValor = 'por-valor',
    PorPontos = 'por-pontos',
    QtdeFixa = 'qtde-fixa',
    QtdeFixaPorAtividade = 'qtde-fixa-por-atividade',
    QtdeVariavelPorAtividade = 'qtde-variavel-por-atividade',
}
